export const containerWidths = {
  sm: 540,
  md: 720,
  lg: 960,
  xl: 1140
};
export function getContainerWidth(breakpoint, span = 12) {
  return `${containerWidths[breakpoint] * span / 12}px`;
}